import { useHistory } from 'react-router-dom';
import l from '../../../../lang';
import { Routes } from '../../../../config/routes';
import Card from '../../../common/card';
import CardTitle from '../../../common/card-title';
import cobrarIcon from '../../../../assets/icons/home/quick-action-cobrar.png';
import pagarIcon from '../../../../assets/icons/home/quick-action-pagar.png';
import retirarIcon from '../../../../assets/icons/home/quick-action-retirar.png';
import movimientosIcon from '../../../../assets/icons/home/quick-action-movimientos.png';
import './styles.scss';

interface QuickAction {
  id: string;
  label: string;
  route: string;
  icon: React.ReactNode;
}

const QuickActionsCard = () => {
  const history = useHistory();

  const actions: QuickAction[] = [
    {
      id: 'collect',
      label: l('menu.item.SIDEBAR_COBRAR'),
      route: Routes.CHARGES,
      icon: <img src={cobrarIcon} alt="" className="home-quick-actions__icon" aria-hidden />,
    },
    {
      id: 'pay',
      label: l('menu.item.SIDEBAR_PAGAR'),
      route: Routes.PAYOUTS,
      icon: <img src={pagarIcon} alt="" className="home-quick-actions__icon home-quick-actions__icon--pagar" aria-hidden />,
    },
    {
      id: 'withdraw',
      label: l('menu.item.SETTLEMENTS'),
      route: Routes.SETTLEMENTS,
      icon: <img src={retirarIcon} alt="" className="home-quick-actions__icon" aria-hidden />,
    },
    {
      id: 'activity',
      label: l('menu.item.SIDEBAR_MOVIMIENTOS'),
      route: Routes.MOVEMENTS,
      icon: <img src={movimientosIcon} alt="" className="home-quick-actions__icon" aria-hidden />,
    },
  ];

  return (
    <Card className="home-quick-actions">
      <CardTitle>{l('home.quickActions.title')}</CardTitle>
      <p className="home-quick-actions__desc">{l('home.quickActions.desc')}</p>
      <div className="home-quick-actions__grid" role="list">
        {actions.map(action => (
          <button
            key={action.id}
            type="button"
            className="home-quick-actions__item"
            role="listitem"
            onClick={() => history.push(action.route)}
          >
            <span className="home-quick-actions__circle">
              {action.icon}
              <span className="home-quick-actions__label">{action.label}</span>
            </span>
          </button>
        ))}
      </div>
    </Card>
  );
};

export default QuickActionsCard;
